export const approvalNote = `<p>Note that Administrator approvals feature in the Admin / Workflow section separate to the below.</p>`

export const pendingApprovals = `<p><strong>Navigation</strong>: Approvals / Pending Approvals</p>
<p><img src='${process.env.PUBLIC_URL}/images/7/1/pending_approval.png'/></p>
<p>This page shows a list of items waiting for approval. You can only access this page if your role has the relevant permissions. If you have subscribed for the relevant Alerts, you will receive an alert when you have a pending approval and will need to check through the approval categories, otherwise you will not be notified and will need to check the approval categories as required.&nbsp;</p>
<p><strong>Key Terms</strong></p>
<p>You will be presented with Pending approval options listed under <strong>Categories</strong>:</p>
<ul>
<li><strong>Transactions:</strong> Approvals for all payment types that require dual approval. Note you may require your Security Card and reader to complete the payment approval.</li>
<li > <strong>Accounts:</strong> Approvals for all changes to Accounts (Create, Edit, Delete)</li>
<li > <strong>Admin:</strong> Approvals for changes to payment preferences&nbsp;</li>
<li > <strong>Pending beneficiaries:</strong> Approvals for changes to beneficiaries (Create, Edit, Delete)</li>
<li > <strong>Beneficiary group:</strong> Approvals for changes to Beneficiary Groups (Create, Edit, Delete)</li>
<li > <strong>Statement preference:</strong> Approvals for changes to statement preferences&nbsp;</li>
<li > <strong>FX Approval:</strong> Approval of the FX rate on a cross currency payment or transfer.</li>

<p>For future dated FX-related payments, behaviour is as follows:</p>
<ol>
<li>&nbsp When creating a payment you choose the execution date and send for Approval</li>
<li>&nbsp First approver approves as normal</li >
<li>&nbsp Final approver approves as normal but does not see any GetFX option to confirm the FX</li>
<li>&nbsp Payment is then displayed in Approved Payments tab as ‘In Process’</li >
<li>&nbsp On the date of execution a Pending Approval is created in the FX Approval section</li>
<li>&nbsp An approver has to go into the Pending Approval/FX Approval and GetFX to confirm the rate and send for processing</li >
<ol>
</ul>
<ul>
<p>For FX-related payments that are to be executed the same day, the Final approver has to confirm the FX (GetFX) during their approval (step 3 above).</p>
</ul>
<ul>
<li > <strong>Sweeps:</strong> Approval of a sweep, where funds are physically swept to/from the participating accounts and the master account</li>
<li > <strong>Templates:</strong> Predefined formats used to create BACS, Faster Payments, CHAPS, and International payments</li>
<li > <strong>Payment Workflows:</strong> Structured processes for managing and approving payment transactions, setting approval ranges and chains for users or groups</li>
<li > <strong>User Approval Groups:</strong> Sets of users authorised to approve transactions</li>
</ul>
<p><strong><u>Broader Process</u></strong></p>
<p><strong>Step 1:</strong></p>
<p>The below uses the example of <strong>Transactions</strong> as an illustration of the process</p>

<p>You will only view approval options that you have permission to access.</p>
<p>The table on the right of the page shows the list of items waiting for approval. Use the dropdown menu in the <strong>Action </strong>column to <strong>Approve</strong>, <strong>Reject</strong> or <strong>Hold</strong> each item.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/7/1/approval_2.png'/></p>
<p><strong>Step 2:</strong></p>
<p>If you <strong>Reject</strong> an item, you must give a reason. You can reject a payment that has an execution date in the past.  You can not approve a payment which has the execution date in the past.</p>
<p>Use the <strong>Approvals action</strong> menu at the top of the table to choose a single action for all pending approval items. Choose <strong>Approve</strong>, <strong>Reject</strong> or <strong>Hold</strong> from the dropdown menu. Then click <strong>Apply to all</strong>.</p>
<p><img src='${process.env.PUBLIC_URL}/images/7/1/approval_3.png'/></p>
<p><strong>Step 3:</strong></p>

<p>When you have made your changes, click <strong>Submit</strong>. A confirmation page will appear to ask you to <strong>verify pending approval actions.</strong> Click <strong>Submit  </strong>to confirm the approval or click <strong>Cancel </strong>to go back to the previous page.</p>
<p>The approval is complete when you <strong>confirm,</strong> and a message will appear to notify you <strong>Decisions taken for pending approval has been saved.</strong> &nbsp; When you click <strong>done</strong> this will take you back to any other pending approvals you may have. </p>
<p><img src='${process.env.PUBLIC_URL}/images/7/1/approval_4.png'/></p>`

export const findapprovalitems = `<table class='table table-bordered'>
<thead>
<tr>
<td>Category</td><td>Navigation to approval</td><td>Navigation to view items waiting to be approved 
</td>
</tr>
</thead>
<tbody>
<tr><td>Payments</td><td>Approvals / Pending approvals/Transactions</td><td>Payments / Summary  / Pending payments</td></tr>
<tr><td>Transfers (optional)</td><td>Approvals / Pending approvals/Transactions</td><td>Payments / Summary  / Pending payments</td></tr>
<tr><td>Payment templates</td><td>Approvals / Pending approvals/Templates</td><td>Payments / Template summary</td></tr>
<tr><td>Beneficiary user group</td><td>Approvals / Pending approvals/Beneficiary group</td><td>Payments / Beneficiaries / Beneficiary user groups</td></tr>
<tr><td>Beneficiaries</td><td>Approvals / Pending approvals/Beneficiaries</td><td>Payments / Beneficiaries / Manage beneficiaries</td></tr>
<tr><td>Payment preferences</td><td>Approvals / Pending approvals/Payment preferences</td><td>Admin / Company / Payment preferences</td></tr>
<tr><td>Admin (add/edit of Admin users)</td><td>Approvals / Pending approvals/Admin</td><td>Admin / Summary
Edit Admin and Edit BP ID display red font when approvals are pending</td></tr>
<tr><td>Accounts </td><td>Approvals / Pending approvals / Accounts</td><td>Account management status report</td></tr>
<tr><td>Statements</td><td>Approvals / Pending approvals / Statement preference</td><td>Reports / Reporting and statements / Request end of day or intra day statement</td></tr>
<tr><td>FX (on future dated cross currency payment)</td><td>Approvals / Pending approvals/FX</td><td>Payments / Summary </td></tr>
<tr><td>Sweep</td><td>Approvals / Pending approvals / Sweeps</td><td></td></tr>
<tr><td>Workflow approval - Users *</td><td>Admin / Workflow</td><td>Admin/Summary</td></tr>
<tr><td>Workflow approval - Payments</td><td>Approvals / Pending approvals / Payment workflows</td><td></td></tr>
<tr><td>User approval groups</td><td>Approvals / Pending approvals / User approval groups</td><td></td></tr>
<tr><td>User Role Profiles (Edit Journey to add accounts or permissions)</td><td>Admin / User Role Profiles</td><td>Admin / User Role Profiles</td></tr>
</tbody>
</table>
<p><strong>* Workflow approvals for users includes:</strong></p>
<p>Create user</p>
<p>Edit user</p>
<p>Reset telephony PIN</p>
<p>Unlock user</p>
<p>Reset user password</p>
<p>Reset user activation code</p>
<p>Order new security card PIN</p>
<p>Cancel security card</p>
<p>Reactivate a security card</p>
<p>Order replacement security device</p>
<p>Reactivate user</p>`



// WEBPACK FOOTER //
// ./src/components/content/approvals.ts